import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      “Rataplán, rataplán, rataplán, plan plan” cantaban los tambores del ejército bajo el mando del Libertador Simón
      Bolívar. Estos sonidos y el sueño de la libertad, llevaron a Jacinto, “un muchachito mestizo, delgaducho por el
      paludismo, pero lleno de nervios y espíritu”, a unirse a los soldados, sus cornetas y caballos para emprender la
      travesía desde la llanura del Casanare y dirigirse hacia el centro del país.
    </p>
    <p className="content justified">
      Jacinto “pronto se hizo estimar de las demás y le dieron un caballejo no muy airoso y una lanza”. Con estos, el
      muchachito valeroso continúo su recorrido y las largas caminatas hasta los páramos.
    </p>
    <p className="content justified">
      El frío, los vientos y la llovizna hicieron que los llaneros entrenados por el General Santander, y ahora bajo la
      guía de Rondón, se estremecieran. Jacinto no fue la excepción: temblaba, sentía el frío penetrante en sus piernas
      desnudas y tenía dificultades para respirar y ver con claridad.
    </p>
    <p className="content justified">
      Animado por el General Bolívar, Jacinto sacó fuerzas para continuar con la empresa libertadora y llegar a la
      batalla del Pantano de Vargas. Para ese entonces, el muchacho estaba ardiendo en fiebre y era tal el grado de la
      enfermedad que empezó a delirar.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      El sueño y la realidad se fueron mezclando con su anhelo de libertad, las batallas, sus intenciones y sus miedos.
      Finalmente, sus sueños y logros lo llevaron a un sueño eterno. Su cuerpo sin vida conmovió al Libertador, mientras
      los tambores seguían sonando “Rataplán, rataplán”.
    </p>
  </div>
);

export const sections = (
  <div className="sectionsReview">
    <div className="sectionReview">
      <h3 className="review-title subtitle">El delirio para hablar de la libertad</h3>
      <p className="content justified">
        Esta es una de las historias más conmovedoras de Oswaldo Díaz Díaz, quien vió en la historia de un niño soñador,
        valiente y comprometido con su patria la oportunidad perfecta para hablar de las batallas libertadoras desde la
        voz de un personaje a quien nunca se le hubiera escuchado desde la llamada Historia oficial.
      </p>
      <p className="content justified">
        En "Rataplán" encontramos dos rasgos sobresalientes de la producción literaria e histórica de Oswaldo Díaz Díaz.
        Por un lado, es usual que en su literatura infantil trabaje como línea temática la historia de Colombia y se
        enfoque en episodios de la Independencia.
      </p>
      <p className="content justified">
        Por otro lado, estos episodios son narrados desde personajes poco nombrados, así que se cuenta la historia desde
        los márgenes, desde la voz y la mirada de aquellos cuyos nombres fueron olvidados por el discurso hegemónico. De
        esta forma, podemos conocer la historia del país desde una nueva perspectiva, más humana, amplia, heterogénea y
        menos oficializada.
      </p>
      <p className="content justified">
        “Rataplán” fue llevada al radioteatro por el grupo escénico juvenil dirigido por José Agustín Pulido Téllez,
        transmitido por la Radiodifusora Nacional de Colombia, en la serie <i>Radioteatro para muchachos</i>.
      </p>
    </div>
  </div>
);
